import { listReport } from './EmployeeByDay/AttendanceEmployee.i18n.ja'

export const attendanceEmployee = {
  listReport,
}
